import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { settingsService } from '../services/settingsService';

export const fetchEmailSignature = createAsyncThunk(
  'emailSignature/fetchEmailSignature',
  async (_, { rejectWithValue }) => {
    try {
      return await settingsService.getEmailSignature();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const saveEmailSignature = createAsyncThunk(
  'emailSignature/saveEmailSignature',
  async (payload, { rejectWithValue }) => {
    try {
      return await settingsService.saveEmailSignature(payload);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const emailSignatureSlice = createSlice({
  name: 'emailSignature',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmailSignature.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmailSignature.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchEmailSignature.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(saveEmailSignature.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveEmailSignature.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(saveEmailSignature.rejected, (state, action) => {
        state.loading = false;
        // Preserve existing cached value — do NOT overwrite data with null
        state.error = action.payload;
      });
  },
});

export const selectEmailSignature = (state) => state.emailSignature.data;
export const selectEmailSignatureLoading = (state) => state.emailSignature.loading;

export default emailSignatureSlice.reducer;
